import { getGeneralError } from '../../../../../common/api/errors'

/** Причина неудачной загрузки справочников: текст бэкенда, иначе текст ошибки страницы. */
export const lookupErrorReason = (error: unknown): string =>
  getGeneralError(error) ?? (error instanceof Error && error.message !== '' ? error.message : 'неизвестная ошибка')
